import { createEpic } from "../helpers";

import {
	getCardsListAsyncAction,
	postCardAsyncAction,
	postManyCardsAsyncAction,
	updateCardAsyncAction,
	getCardAsyncAction,
} from "./cardsActions";

export const getCardsListEpic = createEpic(
	getCardsListAsyncAction,
	"cards",
	"getCardsList",
	true
);

export const postCardEpic = createEpic(
	postCardAsyncAction,
	"cards",
	"postCard",
	true
);

export const postManyCardsEpic = createEpic(
	postManyCardsAsyncAction,
	"cards",
	"postManyCards",
	true
);

export const updateCardEpic = createEpic(
	updateCardAsyncAction,
	"cards",
	"updateCard",
	true
);

export const getCardEpic = createEpic(
	getCardAsyncAction,
	"cards",
	"getCard",
	true
);
